function init() {
	
}

function modalToggle(modal,action) {
	if(modal) {
		var modalElem = document.querySelector(modal);

		if(!action) {
			modalElem.classList.toggle('active');
		} else {
			if(action == 'open') {
				modalElem.classList.add('active');
			} else {
				modalElem.classList.remove('active');
			}
		}

	}
}

window.modalToggle = modalToggle;

export default { init };
